import UIButton from 'components/buttons/UIButton';
import BookmarkIcon from 'components/icons/BookmarkIcon';
import DisabledTooltip from './DisabledTooltip';
import styles from '../PlanCard.module.scss';

interface SaveButtonProps {
  planId: string;
  isSaved: boolean;
  onToggle: () => void;
  isRecommended: boolean;
  lockAfterSave?: boolean;
  iconOnly?: boolean;
  isPending?: boolean;
}

const saveLabel = (isPending: boolean, savedOrRec: boolean) => {
  if (isPending) return 'Saving...';
  if (savedOrRec) return 'Saved';
  return 'Save';
};

const statusText = (isPending: boolean, isSaved: boolean) => {
  if (isPending) return 'Saving plan';
  if (isSaved) return 'Plan saved';
  return '';
};

export default function SaveButton({
  planId,
  isSaved,
  onToggle,
  isRecommended = false,
  lockAfterSave = true,
  iconOnly = false,
  isPending = false,
}: SaveButtonProps) {
  const savedOrRec = isSaved || isRecommended;
  const isDisabled = isRecommended || (lockAfterSave && isSaved) || isPending;
  const tooltipId = `save-tooltip-${planId}`;
  const label = saveLabel(isPending, savedOrRec);

  return (
    <div className={styles.saveButtonWrapper}>
      <UIButton
        buttonType="tonal"
        label={iconOnly ? '' : label}
        aria-label={iconOnly ? label : undefined}
        aria-disabled={isDisabled}
        disabled={isPending}
        onClick={isDisabled ? undefined : onToggle}
        icon={<BookmarkIcon isSaved={savedOrRec} />}
        iconPosition="left"
        aria-describedby={isRecommended ? tooltipId : undefined}
      />
      <span role="status" className="visually-hidden">
        {statusText(isPending, isSaved)}
      </span>
      {isRecommended && (
        <DisabledTooltip
          id={tooltipId}
          message="You can find your ALEX recommended plans on the Saved Plans page."
          horizontalAlignment="left"
          verticalAlignment="top"
        />
      )}
    </div>
  );
}
